var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "alert-box" }, [
    _c("div", { staticClass: "has-text-centered" }, [
      _c(
        "div",
        {
          staticClass:
            "columns is-mobile is-centered is-vcentered is-multiline columns-no-padding-vertical margin-top-xs",
        },
        [
          _c("div", { staticClass: "column is-narrow" }, [
            _vm._v(_vm._s(_vm.$t("home.section_intro.app1"))),
          ]),
          _vm._m(0),
          _c("div", { staticClass: "column is-narrow no-padding-left" }, [
            _c("strong", [_vm._v(_vm._s(_vm.$t("home.section_intro.app2")))]),
          ]),
          _c(
            "div",
            {
              staticClass: "column is-narrow no-padding-left",
              staticStyle: { "max-width": "90vw" },
            },
            [_vm._v(_vm._s(_vm.$t("home.section_intro.app3")))]
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "app-container" },
        [_c("android-app"), _c("ios-app")],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow no-padding-left" }, [
      _c("img", {
        staticStyle: { width: "2rem", display: "block" },
        attrs: { src: "/icon.png", alt: "", draggable: "false" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }